<template>
  <div class="commission-list">
    <breadcrumb :breadcrumbList="breadcrumbList"></breadcrumb>
    <div class="commission-list-content">
      <top-content></top-content>
      <rule-list></rule-list>
    </div>
  </div>

</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import { breadcrumbList } from './config'
import topContent from './cpns/top-content/top-content.vue'
import ruleList from './cpns/rule-list/rule-list.vue'
export default defineComponent({
  props: {

  },
  components: {
    Breadcrumb,
    topContent,
    ruleList
  },
  setup() {


    return {
      breadcrumbList
    }

  }
})
</script>

<style scoped lang="less">
.commission-list {
  min-width: 980px;

  .commission-list-content {
    padding: 20px;
    margin: 20px;
    background-color: #fff;
    min-height: 750px;
  }
}
</style>




